export const ROLE = {
  dialog: "dialog",
  form: "form",
}
